import _ from 'underscore';
import React, { useCallback, useContext, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LegacyShoppingSettings } from '@bingads-webui-campaign-react/legacy-shopping-settings';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { useJsDataContext } from '@bingads-webui-cc-react/js-data-rest';
import { SettingScenarios } from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/utils';

import { getShoppingSettingOptions } from './setting-configs';

const StoreSettingWithCustomValidation = ({
  updateValidation, storeSettingRef, productData, campaignSettings, isSearch, feedData, isCPSSelected,
  onStoreSelectionChange, onSalesCountryChange, onFeedLabelChange, onSelectFilterProducts,
}) => {
  const activity = useContext(ActivityContext);
  const i18n = useContext(I18nContext);
  const ccJsData = useJsDataContext();

  const onChange = useCallback((newData, isValid) => {
    // We are not using the updated data here as we will using the backbone view ref to get the final data
    updateValidation(isValid ? [] : [i18n.getString(_TL_('Legacy store settings has error'))]);
    if (activity && !isValid) {
      // signal activity to parent
      activity.signal(`onLegacyProductFilterChange - ${JSON.stringify(newData)} - isValid: ${isValid}}`);
    }
  }, [updateValidation, activity, i18n]);

  const [storeSettings, setStoreSettings] = useState(undefined);

  useEffect(() => {
    if (campaignSettings && campaignSettings.Id && !storeSettings) {
      setStoreSettings(campaignSettings);
    }
  }, [campaignSettings, storeSettings]);

  const shoppingSettingOptions = useMemo(() => getShoppingSettingOptions({
    isSearch,
    settingScenarioName: SettingScenarios.PAAIMStoreSetting,
    i18n,
    // Due to we separate product filter from store setting. we should ensure storeSetting pass the validation by remove campaignCriterionsData while edit
    productData: _.omit(productData, 'CampaignCriterionsData'),
    feedData,
    campaignSettings: storeSettings,
    activity,
    ccJsData,
    onStoreSelectionChange,
    onSalesCountryChange,
    onFeedLabelChange,
    isCPSSelected,
    onSelectFilterProducts,
  }), [productData, storeSettings, activity, isSearch, ccJsData, feedData, i18n,
    onStoreSelectionChange, isCPSSelected, onSalesCountryChange, onFeedLabelChange, onSelectFilterProducts]);

  return (
    <div>
      <LegacyShoppingSettings
        onChange={onChange}
        shoppingSettingsRef={storeSettingRef}
        shoppingSettingOptions={shoppingSettingOptions}
      />
    </div>
  );
};

StoreSettingWithCustomValidation.propTypes = {
  updateValidation: PropTypes.func.isRequired,
  storeSettingRef: PropTypes.shape({}).isRequired,
  productData: PropTypes.shape({}).isRequired,
  campaignSettings: PropTypes.shape({
    Id: PropTypes.number,
  }),
  isSearch: PropTypes.bool.isRequired,
  feedData: PropTypes.shape({}).isRequired,
  onStoreSelectionChange: PropTypes.func.isRequired,
  isCPSSelected: PropTypes.bool,
  onSalesCountryChange: PropTypes.func.isRequired,
  onFeedLabelChange: PropTypes.func.isRequired,
  onSelectFilterProducts: PropTypes.func.isRequired,
};

StoreSettingWithCustomValidation.defaultProps = {
  campaignSettings: undefined,
  isCPSSelected: false,
};

export const ValidatedStoreSetting = withControlErrorHandling(withUnvalidatedControlErrors(withCustomValidation(StoreSettingWithCustomValidation)));

